export function costFormat (cost: number): string {
    return cost.toLocaleString('ru-RU');
}
